import { ApiService, GetListResponse, ModelBase } from '@app/api/api.service';
import { Injectable } from '@angular/core';

export interface CidDevice extends ModelBase {
  status: string;
  mac_address: string;
  pin_code: string;
  serial: string;
  model: string;
  id: number;
  is_deleted: boolean;
}

interface GetDevicesArguments {
  offset: number;
  limit: number;
}

interface GetDevicesResponse extends GetListResponse {
  devices: CidDevice[];
}

@Injectable({
  providedIn: 'root'
})
export class CidDeviceApiService {
  constructor(
    private apiService: ApiService
  ) {
  }

  public async getCidDevices(args: GetDevicesArguments): Promise<GetDevicesResponse> {
    const { offset, limit } = args;
    return this.apiService.getResponseJson({
      urlPart: '/cid-devices',
      queryStringParams: {
        offset: offset,
        limit: limit
      }
    });
  }

  public async addCidDevice(args: { device: CidDevice }): Promise<{ device: CidDevice }> {
    const { device } = args;
    return this.apiService.getResponseJson({
      urlPart: `/cid-devices/new`,
      method: 'POST',
      data: device
    });
  }

  public async getCidDevice(args: { pinCode: string }): Promise<{ cid_device: CidDevice }> {
    const { pinCode } = args;
    return this.apiService.getResponseJson({
      urlPart: `/cid-devices/${pinCode}`
    });
  }

  public async updateCidDevice(args: { device: CidDevice }): Promise<{ device: CidDevice }> {
    const {device} = args;
    return await this.apiService.getResponseJson({
      urlPart: `/cid-devices/${device.id}`,
      method: 'PUT',
      data: device
    });
  }

  public async deleteCidDevice(args: {device: CidDevice, reason: string}): Promise<void> {
    const {device, reason} = args;
    return await this.apiService.getResponseJson({
      urlPart: `/cid-devices/${device.id}`,
      method: 'DELETE',
      data: {
        reason: reason
      }
    });
}

}
